var _defs, _rect, _path, _path2, _circle, _path3, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefreshWh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}.c{fill:#002445;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29.746,27.015h-.008L3.964,26.754A.75.75,0,0,1,3.222,26V21.949a.75.75,0,0,1,.335-.625l4.16-2.767,4.915-5.1a.75.75,0,0,1,.54-.23H26.1a.75.75,0,0,1,.612.317l3.65,5.159a.75.75,0,0,1,.138.433v7.128a.75.75,0,0,1-.75.75ZM4.722,25.262,29,25.507V19.375l-3.288-4.647H13.49L8.74,19.657a.751.751,0,0,1-.125.1L4.722,22.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.2,19.136"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.98,
    cy: 2.98,
    r: 2.98,
    transform: "translate(8.256 22.848)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.98-.75A3.73,3.73,0,1,1-.75,2.98,3.734,3.734,0,0,1,2.98-.75Zm0,5.959A2.23,2.23,0,1,0,.75,2.98,2.232,2.232,0,0,0,2.98,5.209Z",
    transform: "translate(8.256 22.848)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.98,
    cy: 2.98,
    r: 2.98,
    transform: "translate(20.621 22.848)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.98-.75A3.73,3.73,0,1,1-.75,2.98,3.734,3.734,0,0,1,2.98-.75Zm0,5.959A2.23,2.23,0,1,0,.75,2.98,2.232,2.232,0,0,0,2.98,5.209Z",
    transform: "translate(20.621 22.848)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.652,19.886H8.2v-1.5H18.9V14.313h1.5v4.823A.75.75,0,0,1,19.652,19.886Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29.746,19.886H22.483a.75.75,0,0,1-.75-.75V14.313h1.5v4.073h6.513Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.828,7.985a.75.75,0,0,1,.734.594,5.129,5.129,0,0,0,.861,2.348,4.037,4.037,0,0,0,2.069.926.75.75,0,0,1,0,1.452,4.04,4.04,0,0,0-2.069.927,5.13,5.13,0,0,0-.861,2.348.75.75,0,0,1-1.467,0,5.13,5.13,0,0,0-.861-2.348A4.04,4.04,0,0,0,3.164,13.3a.75.75,0,0,1,0-1.452,4.037,4.037,0,0,0,2.069-.926,5.129,5.129,0,0,0,.861-2.348A.75.75,0,0,1,6.828,7.985Zm1.294,4.594a3.259,3.259,0,0,1-.811-.646,3.377,3.377,0,0,1-.482-.7,3.377,3.377,0,0,1-.482.7,3.259,3.259,0,0,1-.811.646,3.261,3.261,0,0,1,.811.646,3.378,3.378,0,0,1,.482.7,3.378,3.378,0,0,1,.482-.7A3.261,3.261,0,0,1,8.122,12.579Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.893,26.265c-2.437.634-2.9,1.148-3.475,3.844-.573-2.7-1.038-3.21-3.475-3.844,2.437-.634,2.9-1.149,3.475-3.845C27.991,25.116,28.456,25.631,30.893,26.265Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M27.418,31.609a1.5,1.5,0,0,1-1.467-1.188,4.864,4.864,0,0,0-.684-2,3.7,3.7,0,0,0-1.7-.7,1.5,1.5,0,0,1,0-2.9,3.692,3.692,0,0,0,1.7-.7,4.868,4.868,0,0,0,.684-2,1.5,1.5,0,0,1,2.934,0,4.868,4.868,0,0,0,.684,2,3.692,3.692,0,0,0,1.7.7,1.5,1.5,0,0,1,0,2.9,3.7,3.7,0,0,0-1.7.7,4.864,4.864,0,0,0-.684,2A1.5,1.5,0,0,1,27.418,31.609Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.418,30.859a.75.75,0,0,1-.734-.594,5.129,5.129,0,0,0-.861-2.348,4.037,4.037,0,0,0-2.069-.926.75.75,0,0,1,0-1.452,4.035,4.035,0,0,0,2.069-.926,5.132,5.132,0,0,0,.861-2.349.75.75,0,0,1,1.467,0,5.132,5.132,0,0,0,.861,2.349,4.035,4.035,0,0,0,2.069.926.75.75,0,0,1,0,1.452,4.037,4.037,0,0,0-2.069.926,5.129,5.129,0,0,0-.861,2.348A.75.75,0,0,1,27.418,30.859Zm-1.293-4.594a3.259,3.259,0,0,1,.811.646,3.377,3.377,0,0,1,.482.7,3.377,3.377,0,0,1,.482-.7,3.259,3.259,0,0,1,.811-.646,3.26,3.26,0,0,1-.811-.646,3.378,3.378,0,0,1-.482-.7,3.378,3.378,0,0,1-.482.7A3.26,3.26,0,0,1,26.125,26.265Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.172,4.141a.75.75,0,0,1,.734.594,5.129,5.129,0,0,0,.861,2.348,4.037,4.037,0,0,0,2.069.926.75.75,0,0,1,0,1.452,4.035,4.035,0,0,0-2.069.926,5.132,5.132,0,0,0-.861,2.349.75.75,0,0,1-1.467,0,5.132,5.132,0,0,0-.861-2.349,4.035,4.035,0,0,0-2.069-.926.75.75,0,0,1,0-1.452,4.037,4.037,0,0,0,2.069-.926,5.129,5.129,0,0,0,.861-2.348A.75.75,0,0,1,28.172,4.141Zm1.293,4.594a3.259,3.259,0,0,1-.811-.646,3.377,3.377,0,0,1-.482-.7,3.377,3.377,0,0,1-.482.7,3.259,3.259,0,0,1-.811.646,3.26,3.26,0,0,1,.811.646,3.378,3.378,0,0,1,.482.7,3.378,3.378,0,0,1,.482-.7A3.26,3.26,0,0,1,29.465,8.735Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefreshWh);
export default __webpack_public_path__ + "static/media/icon_refresh_wh.75d4d0381ca4be57adc39835818bffbc.svg";
export { ForwardRef as ReactComponent };